// extracted by mini-css-extract-plugin
export default {"nav-links":"Navlinks_nav-links__Gqnkn","active":"Navlinks_active__p2Hm+"};